module.exports = __webpack_public_path__ + "static/media/ic_sent.b27092e6.svg";